import { render, staticRenderFns } from "./tswgdet.vue?vue&type=template&id=b1d0e182&scoped=true&"
import script from "./tswgdet.vue?vue&type=script&lang=js&"
export * from "./tswgdet.vue?vue&type=script&lang=js&"
import style0 from "./tswgdet.vue?vue&type=style&index=0&id=b1d0e182&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d0e182",
  null
  
)

export default component.exports